module.exports = __webpack_public_path__ + "img/extension-commands-win.5aba0fcc.svg";